/**
 * The `marked` token discriminator, kept in a module of its own.
 *
 * This file must never grow an import. Markdown rendering is mutually
 * recursive by design — markdown embeds references, references render
 * markdown, markdown blocks are widgets, and widget labels are markdown again —
 * so `Cmarkdown`, `Cmarkdowntext`, `Creference` and every `Cmarkdown*` widget
 * form one large import cycle. In a cycle the module the bundler happens to
 * enter first hands the others a namespace whose bindings are still
 * `undefined`, so reading one at MODULE SCOPE throws
 * "Cannot read properties of undefined" — and which module is entered first
 * shifts with any unrelated import edit elsewhere in the app.
 *
 * A module with no imports can never be mid-evaluation when someone reads it,
 * so its bindings are always defined. That is the only reason this enum does
 * not live next to the renderer that uses it most: the block renderer builds
 * its token→renderer table at module scope, and that table must not be able to
 * fault. Keep shared markdown *data* here; keep behaviour in the renderers.
 */
export enum MarkdownTokenType {
  Paragraph = 'paragraph',
  HTML = 'html',
  Strong = 'strong',
  Emphasis = 'em',
  Del = 'del',
  CodeSpan = 'codespan',
  Link = 'link',
  Text = 'text',
  Escape = 'escape',
  LineBreak = 'br',
  Heading = 'heading',
  Blockquote = 'blockquote',
  List = 'list',
  Code = 'code',
  HorizontalRule = 'hr',
  Image = 'image',
  Table = 'table',
  Space = 'space',
}
